import Vue from "vue";
import api from "@/api";
import deepClone from "@/utils/deep-clone";

const DEFAULTS = {
    ITEMS_PER_PAGE: 250,
};

/**
 * STATE
 */
const state = {
    companyNotifications: [],
    notificationTypes: [],
    isLoadMoreNotificationsActive: false,
};

/**
 * GETTERS
 */
const getters = {
    companyNotifications(state) {
        return deepClone(state.companyNotifications);
    },
    notificationTypes(state) {
        return deepClone(state.notificationTypes);
    },
    isLoadMoreNotificationsActive(state) {
        return deepClone(state.isLoadMoreNotificationsActive);
    },
};

/**
 * ACTIONS
 */
const actions = {
    getCompanyNotifications(
        { commit },
        { payload: { extend = false, queryParams = "" } } = { payload: {} },
    ) {
        return api.get(`/api/notifications${queryParams}`).then(({ data }) => {
            if (!extend) {
                commit("setCompanyNotifications", { notifications: data });
            } else {
                commit("extendCompanyNotifications", { notifications: data });
            }

            if (Array.isArray(data) && data.length && data.length >= DEFAULTS.ITEMS_PER_PAGE) {
                commit("setLoadMoreState", true);
            } else {
                commit("setLoadMoreState", false);
            }
        });
    },
    getNotificationTypes({ commit }) {
        return api.get("/api/notifications/types").then(({ data }) => {
            commit("setNotificationTypes", { types: data });
        });
    },
    resetNotificationDelivery({ commit }, { payload: { notificationId = "" } } = { payload: {} }) {
        return api.patch(`/api/notifications/${notificationId}/reset-delivery`).then(({ data }) => {
            commit("updateSingleNotification", { notification: data });
        });
    },
};

/**
 * MUTATIONS
 */
const mutations = {
    setCompanyNotifications(state, { notifications = [] } = {}) {
        state.companyNotifications = notifications;
    },
    extendCompanyNotifications(state, { notifications = [] } = {}) {
        state.companyNotifications = [...state.companyNotifications, ...notifications];
    },
    setNotificationTypes(state, { types = [] } = {}) {
        state.notificationTypes = types;
    },
    updateSingleNotification(state, { notification = {} } = {}) {
        for (const [index, companyNotification] of state.companyNotifications.entries()) {
            if (notification._id === companyNotification._id) {
                Vue.set(state.companyNotifications, index, notification);
                break;
            }
        }
    },
    setLoadMoreState(state, isLoadMoreNotificationsActive = false) {
        state.isLoadMoreNotificationsActive = isLoadMoreNotificationsActive;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
